export const COMMENT_HASH_REGEX = /#cm_\w+/

export const SUPPORT_USER_ID = 'SUPPORT_USER'
